import React, { useCallback, useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import BreadCrumb from "../Common/BreadCrumb";
import { ToastContainer } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../Utils/Loader";
import { fetchOperatorbyId } from "../../slices/OperatorManagement/GetOperatorbyID/thunk";
import { logoViewDoc } from "../../slices/Logo/thunk";
import { documentUpdateFile } from "../../slices/customer/documentupdatefile/thunk";
import { partnerUploadDocument } from "../../slices/PartnerMangement/PartnerDocumentUpload/thunk";
import CreateOperatorProvider from "./createOperatorProvider";
import logoLarge from "../../assets/images/users/user-dummy-img.jpg";
import {
    countryOptionss,
    OperatorOptionsFields,
    OperatorStatusOptions,
} from "../OperatorManagement/Constant/Options";
import BusinessDetails from "./BusinessDetails";
import moment from "moment";
import { fetchCountries } from "../../slices/customer/countries/thunk";
import { getUserByName } from "../../slices/UserManagement/GetUserByName/thunk";
import imagePlaceholder from ".././../assets/images/image-placeholder.jpg"
import { hasPermission } from "../Utils/UtilityFunctions";
export default function OperatorProfile() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [update, setUpdate] = useState(false);
    const [profileData, setProfileData] = useState(null);
    const [profileImage, setProfileImage] = useState(logoLarge);
    const [fileSelected, setFileSelected] = useState(false);
    const [callState, setCallState] = useState(false)
    const [systemUser, setSystemUser] = useState({})
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );

    const profilePermission = hasPermission(permissionsMap, "administration", "profileManagement")

    const toggle = () => {
        setIsEdit(!isEdit)
    };

    const roleName = localStorage.getItem("roleName");
    const userName = localStorage.getItem("userName");
    const operatorId = localStorage.getItem("operatorId")?.split("/").pop();
    const userId = localStorage.getItem("userId");
    const [initialValues, setInitialValues] = useState({
        businessName: "",
        Domain: "",
        state: "",
        city: "",
        zipCode: "",
        endDate: null,
        Address: "",
        Address2: "",
        country: "",
        firstname: "",
        lastname: "",
        username: "",
        phone: "",
        email: "",
        Status: "",
    })

    const operatorOptions = [
        { name: "Domain", value: "Operator", options: OperatorOptionsFields },
        { name: "country", value: "Operator", options: countryOptionss },
        { name: "Status", value: "Operator", options: OperatorStatusOptions },
    ];

    // Fetch operator details when isEdit is true
    // useEffect(() => {
    //     if (isEdit && operatorId) {
    //         dispatch(
    //             fetchOperatorbyId(
    //                 setLoading,
    //                 operatorId,
    //                 initialValues,
    //                 operatorOptions,
    //                 OperatorStatusOptions
    //             )
    //         );
    //     }
    // }, [dispatch, isEdit, operatorId]);

    // Fetch logo document based on role
    useEffect(() => {
        const partnerOrCustomer = "Business";
        if (roleName === "systemUser" && userId) {
            dispatch(getUserByName(userId, setLoading, initialValues, setSystemUser));
            dispatch(
                logoViewDoc(
                    setLoading,
                    userId,
                    "logoSys",
                    partnerOrCustomer,
                    setProfileData
                )
            );
        } else if (operatorId) {
            dispatch(
                logoViewDoc(
                    setLoading,
                    operatorId,
                    "logo",
                    partnerOrCustomer,
                    setProfileData
                )
            );
        }
    }, [dispatch, roleName, operatorId, userId]);

    const operatorData = useSelector(
        (state) => state?.GetOperator?.GetOperatorId ?? null
    );
    const ViewDocument = useSelector((state) => state.LogoView.logoView) || [];
    const base64ImageData = ViewDocument?.filePath || null;

    // Set profile image when document data changes
    useEffect(() => {
        if (base64ImageData) {
            setProfileImage(base64ImageData);
        }
    }, [base64ImageData]);

    // Function to create form data for upload
    const createDocumentJson = useCallback(
        (file, isUpdate) => {
            const formData = new FormData();
            const id = roleName === "systemUser" ? userId : operatorId;
            if (!id) {
                console.error("User/Operator ID is missing");
                return;
            }
            formData.append("ID", id);
            formData.append("file", file);
            formData.append(
                "documentName",
                roleName === "systemUser" ? "logoSys" : "logo"
            );
            formData.append(
                "documentType",
                roleName === "systemUser" ? "logoSys" : "logo"
            );
            formData.append("userType", "operator");
            formData.append(
                "uploadedBy",
                roleName === "systemUser" ? userName : "Operator"
            );

            if (isUpdate) {
                formData.append("newDocumentName", formData.get("documentName"));
            }
            return formData;
        },
        [roleName, userId, operatorId]
    );

    // Upload or update document
    const uploadDocApiCall = useCallback(
        (file) => {
            const partnerOrCustomer = "Business";
            const id = roleName === "systemUser" ? userId : operatorId;

            if (!id) {
                console.error("User/Operator details missing");
                return;
            }

            if (base64ImageData) {
                const updateObj = createDocumentJson(file, true);
                dispatch(
                    documentUpdateFile(
                        setLoading,
                        updateObj,
                        id,
                        null,
                        partnerOrCustomer,
                        setUpdate,
                        setFileSelected,
                        navigate
                    )
                );
            } else {
                const documentObj = createDocumentJson(file, false);
                dispatch(
                    partnerUploadDocument(
                        documentObj,
                        setLoading,
                        id,
                        null,
                        partnerOrCustomer,
                        setFileSelected,
                        navigate
                    )
                );
            }
        },
        [
            dispatch,
            roleName,
            userId,
            operatorId,
            base64ImageData,
            createDocumentJson,
        ]
    );

    // Handle Image Upload
    const handleImageUpload = (file) => {
        if (file) {
            setFileSelected(true);
            const reader = new FileReader();
            reader.onload = (e) => setProfileImage(e.target.result);
            reader.readAsDataURL(file);
            uploadDocApiCall(file);
        }
    };
    useEffect(() => {
        setInitialValues({
            businessName: operatorData?.tradingName || "",
            Domain: operatorOptions?.find(optr => optr?.name === 'Domain').options?.find(option => option?.value === operatorData?.domain),
            state: { value: operatorData?.state, label: operatorData?.state },
            city: { value: operatorData?.city, label: operatorData?.city },
            zipCode: operatorData?.postcode,
            endDate: moment(operatorData?.existsDuring?.endDateTime),
            Address: operatorData?.street1,
            Address2: operatorData?.street2,
            country: { value: operatorData?.country, label: operatorData?.country },
            firstname: operatorData?.adminDetails?.profile?.firstName,
            lastname: operatorData?.adminDetails?.profile?.lastName,
            username: operatorData?.adminDetails?.userName,
            phone: operatorData?.adminDetails?.dialCode + operatorData?.adminDetails?.phone,
            email: operatorData?.adminDetails?.email,
            Status: OperatorStatusOptions?.find(option => option?.value === operatorData?.status),
            isSSOUser: operatorData?.adminDetails?.isSSOUser || false
        })
    }, [operatorData])

    useEffect(() => {
        dispatch(fetchCountries(setLoading, setCallState))
    }, [dispatch]);
    return (
        <React.Fragment>
            <div id="csms" className="page-content bg-white">
                <Container fluid>
                    <BreadCrumb title={"Business Profile"} />
                    <h5 class="rv-page-title py-2">View Business Profile</h5>
                    <div className="d-flex justify-content-center my-5">
                        <Row className="flex-grow-1"  style={roleName != "systemUser" ? { maxWidth: "80%" } : {}}>
                            <Col lg={roleName !== "systemUser" ? 12 : 12}>
                                <div
                                    className={`d-flex justify-content-between flex-wrap flex-column flex-md-row ${roleName == "systemUser" ? "border border-1 p-3" : ""
                                        }`}
                                >

                                    <div className="d-flex flex-column flex-sm-row align-items-center mb-3 mb-md-0">
                                        <img
                                            src={profileImage}
                                            className={`rounded-0 offer-bg-color img-thumbnail user-profile-image ${roleName=="systemUser"? "w-h-246":"w-h-130"}`}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = imagePlaceholder
                                            }}
                                            alt="user-profile"
                                        />
                                        <h3 className="text-black ms-4  my-3 my-sm-0 fw-bold align-self-center">
                                            {roleName !== "systemUser"
                                                ? `${operatorData?.tradingName || operatorData?.businessName || ""}`
                                                : `Blueocean`
                                            }

                                        </h3>
                                    </div>
                                    {profilePermission && profilePermission?.has("update") &&
                                        <div className="text-center text-md-end mt-2 ms-2">

                                            <button
                                                type="button"
                                                onClick={() => {
                                                    const isPartner = roleName === 'EVPartnerAdmin' || roleName === 'ISPPartnerAdmin' || roleName === 'partnerAdmin';
                                                    dispatch(fetchOperatorbyId(setLoading, operatorId, initialValues, operatorOptions, OperatorStatusOptions, () => { }, isPartner));
                                                    toggle()
                                                }}
                                                class="btn-label rv-primary-btn me-2 rounded-1 px-4 py-1 text-nowrap btn btn-secondary"
                                            >
                                                <i class="ri-edit-box-line label-icon align-middle fs-16 me-1"></i>
                                                <span class="ps-3 ms-2 me-1">Edit</span>
                                            </button>


                                        </div>}
                                </div>
                                <div></div>
                            </Col>

                            {roleName !== "systemUser" ? (
                                <Col>
                                    <div>
                                        <BusinessDetails />
                                    </div>
                                </Col>
                            ) : null}
                        </Row>
                    </div>
                    <Modal isOpen={isEdit} toggle={toggle} centered={true} className="custom-modal-width-850 editBussinessProfileModal">
                        <ModalHeader
                            className="d-flex justify-content-center align-items-center rv-breadcrumb-border p-3"
                            fade={false}
                        >
                            <div className="w-100 text-center">
                                Edit Business Profile
                            </div>
                            <button type="button" className="close-button-currency mt-n1 fs-1 align-self-center" onClick={toggle}>
                                &times;
                            </button>
                        </ModalHeader>
                        <ModalBody>
                            <CreateOperatorProvider
                                isEdit={isEdit}
                                initialValues={initialValues}
                                handleImageUpload={handleImageUpload}
                                callState={callState}
                                roleName={roleName}
                                profileImage={profileImage}
                                setProfileImage={setProfileImage}
                            />
                        </ModalBody>
                    </Modal>
                </Container>
                {loading && <Loader />}
            </div>
        </React.Fragment>
    );
}
